// extracted by mini-css-extract-plugin
export default {"fab":"WalletConnect_fab__NdOZQ"};